<template>
  <div class="bg-navy-800 rounded-lg p-10 mb-6 text-center text-white">
    <p class="font-medium text-3xl mb-4">
      <slot name="title">
        We'll have to use the
        <a
          href="https://docs.google.com/spreadsheets/d/1PM72gjaNHsfTFls2ehYMH72jixjkL0LrW3AsgQfo-MU/copy?id=1PM72gjaNHsfTFls2ehYMH72jixjkL0LrW3AsgQfo-MU&copyCollaborators=true&copyComments=false&title=%5BNAME%5D+-+Better+Off+With+Beam+Budgeting&copyDestination=1fSmousatrg6OJ4RI-Bne5RC0weL4Iq_4"
          target="_blank"
          class="underline"
          >Better Off With Beam Google Sheet</a
        >
        to calculate this budget.
      </slot>
    </p>
    <p class="text-2xl">
      <slot name="body">
        This is because you live with adults who aren't your partner
      </slot>
    </p>
  </div>
</template>
<script>
export default {}
</script>
